module.exports = __webpack_public_path__ + "img/amanys.e3fc9309.jpg";